<template>
  <!--<div class="loading-overlay">-->
  <div class="modal-content">
    <div class="content-container">
      <img src="@/assets/images/muni/OkVerde.svg" alt="" class="icon-img" />
      <div class="message">
        <p class="h1-heroMuni">{{ message?.one ?? "Exitoso!"}}</p>
        <p class="h1-heroMuni">{{ message?.two ?? "" }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  message: {
    type: Object,
    default: null,
  },
});
</script>

<style scoped>
.modal-content {
  display: flex;
  /* height: 100%; */
  height: 47vh;
  width: 40vw;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
}

.content-container {
  display: flex;
  flex-direction: column;
  gap: 1.88rem;
  align-items: center;
}

.h1-heroMuni {
  /* font-size: 18px; */
  margin: unset;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.25rem; /* 111.111% */
}

.icon-img {
  width: 5.3125rem;
  height: 5.3125rem;
}

.message {
  display: flex;
  flex-direction: column;
  align-items: center;
  word-wrap: break-word;
}

/* -------------------------------------------------------------------------- */
/* RESPONSIVE MOBILE STYLES                         */
/* -------------------------------------------------------------------------- */

/* Define el punto de corte (breakpoint) para móvil, por ejemplo, 768px */
@media (max-width: 768px) {
  /* Contenedor principal del modal */
  .modal-content {
    /* Fija la altura total del modal, aprovechando el espacio desde abajo */
    height: 40vh;
    width: 80vw;

    /* Asegura que el contenido interno pueda scrollear */
    overflow: hidden; /* Esto ya estaba, pero lo confirmamos */
  }
}
</style>
